import Filter from './filter';
import PaginationAction from './pagination-action';
import PaginationControls from './pagination-controls';
import Header from './header';
import { Container, Table, ConfigurationProvider } from './table';
import PaginationBar from './pagination-bar';
import { TableCell } from './table-cell';
import PaginationMeta from './pagination-meta';
import Background from './background';
import Footer from './footer';
import BasicComposition from './basic-composition';

export class Datatable {
  // Configuration
  static Container = Container;
  static ConfigurationProvider = ConfigurationProvider;
  // Primary components
  static Table = Table;
  static Header = Header;
  static Footer = Footer;
  static Filter = Filter;
  static Background = Background;
  // Low level components
  static Cell = TableCell;
  static PaginationAction = PaginationAction;
  static PaginationMeta = PaginationMeta;
  static PaginationControls = PaginationControls;
  // Composition components
  static Basic = BasicComposition;
}

export { PaginationBar };

export type { ColumnDefinition, DatatableProps, RowModel } from './types';
